import { AsyncAction } from "src/state/_types";
import { User_Roles_Enum, User_Type_Enum } from "src/state/gql/_types";
import logger from "src/utils/logger";

import { EmailVerificationClaim } from "supertokens-web-js/recipe/emailverification";
import Session from "supertokens-web-js/recipe/session";

export const refreshSession: AsyncAction = async ({state}) => {

    logger(`Session Refreshed`)

    if (await Session.doesSessionExist()) {

        logger(`Session Exists`)

        let tokenPayload = await Session.getAccessTokenPayloadSecurely()
        state.auth.token = await Session.getAccessToken() || null

        logger(`Got Session Token`)

        state.auth.session_id = tokenPayload['sessionHandle']
        state.auth.user_id =  tokenPayload['https://hasura.io/jwt/claims']['x-hasura-user-id'] || null
        state.auth.tenant_id =  tokenPayload['https://hasura.io/jwt/claims']['x-hasura-tenant-id'] || null
        state.auth.user_type = tokenPayload['https://hasura.io/jwt/claims']['x-hasura-user-type'] || null
        state.auth.agency_id =  tokenPayload['https://hasura.io/jwt/claims']['x-hasura-agency-id'] || null

        logger('Validating Claims')
        let validationErrors = await Session.validateClaims();
        if (validationErrors.length) {
            for (const err of validationErrors) {
                if (err.id === EmailVerificationClaim.id) {
                    state.auth.user_role = 'unverified' as User_Roles_Enum
                }
            }
        } else {

            state.auth.user_role = tokenPayload['https://hasura.io/jwt/claims']['x-hasura-default-role'] || null

        }

        logger(`Session Refreshed`)

    } else {
        state.auth.user_role = User_Roles_Enum.Guest
        state.auth.user_type = User_Type_Enum.Operations
    }
}
